import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';

export enum SmartPowerReportActionTypes {
  GetSmartPowerReportList = '[SmartPowerReport] Get Smart Power Report List',
  UpsertSmartPowerReportList = '[SmartPowerReport] Upsert Smart Power Report List',
  GetSmartPowerReportListFail = '[SmartPowerReport] Get Smart Power Report List Fail',
  GetSmartPowerReport = '[SmartPowerReport] Get Smart Power Report',
  UpsertSmartPowerReport = '[SmartPowerReport] Upsert Smart Power Report',
  GetSmartPowerReportFail = '[SmartPowerReport] Get Smart Power Report Fail',
  UpdateSmartPowerReport = '[SmartPowerReport] Update Smart Power Report',
  UpdateSmartPowerReportSuccess = '[SmartPowerReport] Update Smart Power Report Success',
  UpdateSmartPowerReportFail = '[SmartPowerReport] Update Smart Power Report Fail',
  DeleteSmartPowerReport = '[SmartPowerReport] Delete Smart Power Report',
  DeleteSmartPowerReportSuccess = '[SmartPowerReport] Delete Smart Power Report Success',
  DeleteSmartPowerReportFail = '[SmartPowerReport] Delete Smart Power Report Fail',
  GetSmartPowerReportData = '[SmartPowerReport] Get Smart Power Report Data',
  UpsertSmartPowerReportData = '[SmartPowerReport] Upsert Smart Power Report Data',
  GetSmartPowerReportDataFail = '[SmartPowerReport] Get Smart Power Report Data Fail',
}

export class GetSmartPowerReportList implements Action {
  readonly type = SmartPowerReportActionTypes.GetSmartPowerReportList;

  constructor(public payload: any = null) {}
}

export class UpsertSmartPowerReportList implements Action {
  readonly type = SmartPowerReportActionTypes.UpsertSmartPowerReportList;

  constructor(public payload: any = null) {}
}

export class GetSmartPowerReportListFail implements Action {
  readonly type = SmartPowerReportActionTypes.GetSmartPowerReportListFail;
  
  constructor(public payload: any = null) {}
}

export class GetSmartPowerReport implements Action {
  readonly type = SmartPowerReportActionTypes.GetSmartPowerReport;

  constructor(public payload: any = null) {}
}

export class UpsertSmartPowerReport implements Action {
  readonly type = SmartPowerReportActionTypes.UpsertSmartPowerReport;

  constructor(public payload: any = null) {}
}

export class GetSmartPowerReportFail implements Action {
  readonly type = SmartPowerReportActionTypes.GetSmartPowerReportFail;
  
  constructor(public payload: any = null) {}
}

export class UpdateSmartPowerReport implements Action {
  readonly type = SmartPowerReportActionTypes.UpdateSmartPowerReport;

  constructor(public payload: any = null) {}
}

export class UpdateSmartPowerReportSuccess implements Action {
  readonly type = SmartPowerReportActionTypes.UpdateSmartPowerReportSuccess;

  constructor(public payload: any = null) {}
}

export class UpdateSmartPowerReportFail implements Action {
  readonly type = SmartPowerReportActionTypes.UpdateSmartPowerReportFail;
  
  constructor(public payload: any = null) {}
}

export class DeleteSmartPowerReport implements Action {
  readonly type = SmartPowerReportActionTypes.DeleteSmartPowerReport;

  constructor(public payload: any = null) {}
}

export class DeleteSmartPowerReportSuccess implements Action {
  readonly type = SmartPowerReportActionTypes.DeleteSmartPowerReportSuccess;

  constructor(public payload: any = null) {}
}

export class DeleteSmartPowerReportFail implements Action {
  readonly type = SmartPowerReportActionTypes.DeleteSmartPowerReportFail;
  
  constructor(public payload: any = null) {}
}

export class GetSmartPowerReportData implements Action {
  readonly type = SmartPowerReportActionTypes.GetSmartPowerReportData;

  constructor(public payload: any = null) {}
}

export class UpsertSmartPowerReportData implements Action {
  readonly type = SmartPowerReportActionTypes.UpsertSmartPowerReportData;

  constructor(public payload: any = null) {}
}

export class GetSmartPowerReportDataFail implements Action {
  readonly type = SmartPowerReportActionTypes.GetSmartPowerReportDataFail;
  
  constructor(public payload: any = null) {}
}

export type SmartPowerReportActions =
 GetSmartPowerReportList
 | UpsertSmartPowerReportList
 | GetSmartPowerReportListFail
 | GetSmartPowerReport
 | UpsertSmartPowerReport
 | GetSmartPowerReportFail
 | UpdateSmartPowerReport
 | UpdateSmartPowerReportSuccess
 | UpdateSmartPowerReportFail
 | DeleteSmartPowerReport
 | DeleteSmartPowerReportSuccess
 | DeleteSmartPowerReportFail
 | GetSmartPowerReportData
 | UpsertSmartPowerReportData
 | GetSmartPowerReportDataFail;
